import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {type ExpressionPath, Expressions} from '@packages/systems/wfdl';
import {
  isStringElement,
  isLineBreakElement,
  isIframeElement,
} from '@packages/utilities/elementTypeUtils';

import {isUnselectableVariationElement} from './OptimizeTypeUtils';

const passwordPageHiddenInputPath: ExpressionPath = [
  {in: 'Record', at: 'form'},
  {in: 'Record', at: 'passwordPageHiddenInput'},
];

/**
 * Some special elements on our `password` utility page need to be hidden the
 * user.
 *
 * FIXME: Can we generalize this so any element can be marked as such? Should
 * we?
 */
const isPasswordPageHiddenInput = (element: ExpressionElement): boolean =>
  Expressions.getIn(
    Expressions.getElementData(element),
    passwordPageHiddenInputPath
  ) != null;

/**
 * Some elements should not be selectable on the canvas or from the navigator.
 */
export const isUnselectableElement = (el: ExpressionElement): boolean => {
  return (
    isStringElement(el) ||
    isLineBreakElement(el) ||
    isIframeElement(el) ||
    isPasswordPageHiddenInput(el) ||
    isUnselectableVariationElement(el)
  );
};
